// function to transform values to colors
  export function getColorOrValue(pField: string | number, pMode: string) {  
    let value = pMode === 'css' ? '#000' : 0;
    switch (pField) {
      case 'BLEU':
      case 4: {
        value = pMode === 'css' ? '#4f23fe' : 4;
        break;
      }
      case 'ROUGE':
      case 3: {
        value = pMode === 'css' ? '#FE3123' : 3;
        break;
      }
      case 'ORANGE':
      case 2: {
        value = pMode === 'css' ? '#FFBF66' : 2;
        break;
      }
      case 'VERT':
      case 1: {
        value = pMode === 'css' ? '#63D1B4' : 1;
        break;
      }
      case 'VIOLET':
      case 0.5:  // Handle the case for 'VIOLET' or 0.5
       {
        value = pMode === 'css' ? '#A500B5' : 0.5;
        break;
      }
      default: {
        break;
      }
    }
  return value;
}

// Criticalities data infos
export const Criticalities = [
    {
      title:
        'DO/TP : taux de remontée des données de télégestion du point limite aval du bassin de collecte pour les temps de déversement, nombres de déversement et volumes déversé',
      colors: [
        { 3: 'Taux < 75%' },
        { 2: '75% ≤ Taux < 90%' },
        { 1: 'Taux ≥ 90%' },
      ],
    },
    {
      title:
        'PR/MR : taux de remontée des données de télégestion du point limite aval du bassin de collecte pour les temps de pompage, nombres de démarrage de pompe et volumes pompés',
      colors: [
        { 3: 'Taux < 75%' },
        { 2: '75% ≤ Taux < 90%' },
        { 1: 'Taux ≥ 90%' },
      ],
    },
    {
      title:
        "ECP : Moyenne des Indices Linéaires d’Infiltration (ILI) calculés sur l'année N-1 en m³/j/km ",
      colors: [
        { 3: 'ILI > Seuil très sensible*' },
        { 2: 'Seuil peu sensible*≤ ILI ≤ Seuil très sensible*' },
        { 1: 'ILI < Seuil très sensible*' },
      ],
    },
    {
      title:
        'H2S : Note terrain H2S calculée la plus récente ou à défaut moyenne de la note « temps de séjour canalisation »  (TS) sur la période sèche**',
      colors: [
        { 3: 'Risque fort ou TS> 6h' },
        { 2: 'Risque Moyen ou 4h ≤ TS ≤ 6h' },
        { 1: 'Risque faible  ou TS < 4h ' },
      ],
    },
    {
      title: 'Indus : Risque Industriel sur le bassin de collecte ',
      colors: [
        { 3: 'Au moins 1 industriel « à fort risque » ' },
        {
          2: 'Au moins 1 industriel « à risque » et aucun industriel « à fort risque » ',
        },
        { 1: 'Absence d’industriel « à risque » ou « à fort risque ' },
      ],
    },
    {
      title: 'Hydro : Nombre de Point Noir sur le bassin de collecte',
      colors: [
        { 3: 'Nb Point Noir > nb Point Noirs critique***' },
        { 2: '1 ≤ Nb Point Noir ≤ Point Noirs critique***' },
        { 1: 'Absence de point noir' },
      ],
    },
    {
      title:
        'Milieu : Note de sensibilité du milieu la plus critique de l’ensemble des points de rejet (TP/DO ou STEP) du bassin de collecte',
      colors: [
        { 3: 'Note criticité >250' },
        { 2: '120 ≤ Note criticité ≤ 250' },
        { 1: 'Note criticité <120' },
      ],
    },
    {
      title:
        'Pluie : Analyse des déversements par temps de pluie sur les DO et TP du bassin de collecte',
      colors: [
        {
          3: 'Au moins 1 déversement par temps sec et pas de déversement par temps de pluie',
        },
        { 4: 'Au moins 1 déversement par temps de pluie ' },
        { 1: 'Aucun déversement' },
      ],
    },
  ];

  export const getYearStartAndEndDatesFormatted = (year: number) => {
    const firstDay = new Date(year, 0, 1).toLocaleDateString('fr-FR'); // Format français
    const lastDay = new Date(year, 11, 31).toLocaleDateString('fr-FR');
    return { firstDay, lastDay };
  };